import Swal from 'sweetalert2';
var AlertService = (function () {
    function AlertService() {
    }
    AlertService.prototype.toastNotify = function (_a) {
        var type = _a.type, text = _a.text, timer = _a.timer;
        var Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: timer,
        });
        return Toast.fire({
            type: type,
            text: text,
        });
    };
    return AlertService;
}());
export { AlertService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/alert.service.ts.pre-build-optimizer.js